import { render, staticRenderFns } from "./repayment-button.vue?vue&type=template&id=4e277b86"
import script from "./repayment-button.vue?vue&type=script&lang=ts"
export * from "./repayment-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports